// @flow
import { createAction } from 'redux-actions';
import { payloadCreator } from '@ux/fabric';

// Action Types
const prefix = '@@dst/S_';
export const PURCHASE_DOMAIN = `${prefix}PURCHASE_DOMAIN`;
export const PURCHASE_BUNDLE = `${prefix}PURCHASE_BUNDLE`;
export const SEED = `${prefix}SEED`;
export const SEARCH = `${prefix}SEARCH`;
export const FILTER = `${prefix}FILTER`;
export const TRANSFER = `${prefix}TRANSFER`;
export const BACKORDER = `${prefix}BACKORDER`;
export const NEGOTIATE = `${prefix}NEGOTIATE`;
export const CONFIRM_NEGOTIATE = `${prefix}CONFIRM_NEGOTIATE`;
export const VIEW_BASKET = `${prefix}VIEW_BASKET`;
export const EMIT = `${prefix}EMIT`;

// Action Creators
export const purchaseDomain = createAction(
  PURCHASE_DOMAIN,
  payloadCreator([ 'fqdn' ])
);

export const purchaseBundle = createAction(
  PURCHASE_BUNDLE,
  payloadCreator([ 'fqdn', 'bundles' ]),
);

export const seed = createAction(
  SEED,
  payloadCreator([
    'query',
    'brandId',
    'locale',
    'exchangeRate',
    'minTldLength',
    'bundle',
    'features',
    'asyncHooks',
    'usePPE',
    'includeTax',
    'unspunTlds',
    'filters',
  ])
);

export const search = createAction(SEARCH, (query, filters) => ({
  query,
  filters,
}), (query, filters, source) => ({
  source,
}));

export const filter = createAction(FILTER, payloadCreator([ 'filters' ]));
export const transfer = createAction(TRANSFER, payloadCreator([ 'fqdn' ]));
export const backorder = createAction(BACKORDER, payloadCreator([ 'fqdn' ]));
export const negotiate = createAction(NEGOTIATE, payloadCreator([ 'fqdn' ]));
export const confirmNegotiate = createAction(
  CONFIRM_NEGOTIATE,
  payloadCreator([ 'fqdn' ]),
);
export const viewBasket = createAction(
  VIEW_BASKET,
  ({ source }) => ({ source }),
);

export const emit = createAction(
  EMIT,
  payloadCreator([ 'hook', 'payload', 'allowAsync' ]),
);
